import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "place-bid-wrapper"
}
const _hoisted_2 = { class: "locked-bidding-btn-wrapper" }
const _hoisted_3 = { class: "label-locked-btn" }
const _hoisted_4 = {
  key: 1,
  class: "place-bid-wrapper"
}
const _hoisted_5 = { class: "place-bid-block" }
const _hoisted_6 = { class: "current-bid-anim" }
const _hoisted_7 = {
  key: 0,
  class: "bid-controllers"
}
const _hoisted_8 = { class: "switch-block-bid-button-mob" }
const _hoisted_9 = { class: "switch" }
const _hoisted_10 = { class: "locked-button-label" }
const _hoisted_11 = {
  key: 1,
  class: "label-locked-btn"
}
const _hoisted_12 = {
  key: 1,
  class: "need-login-block"
}
const _hoisted_13 = {
  href: "/login",
  class: "btn btn-sky-blue need-login-btn"
}
const _hoisted_14 = {
  key: 0,
  class: "fast-bids-short"
}
const _hoisted_15 = { class: "fast-bids-variants" }
const _hoisted_16 = ["onClick"]

import { computed, watch, onMounted, onUnmounted, ref, Ref } from "vue";
  import Api from "@/services/api";
  import FastBidVariantsToggle from "@/components/_partials/FastBidVariantsToggle.vue";
  import { IPopupError } from "@/models";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { useToast } from "primevue/usetoast";
  import { format_currency } from "@/utils/currencies";
  import { trans } from "@/utils/trans";
  import CurrencyConverted from "@/components/_partials/CurrencyConverted.vue";
  import { LockIcon, UnlockIcon, BaseIcon } from "@/components/icons";

  import clickEffect from "@/assets/sounds/live_click.wav";
  import { LotStatuses } from "@/enum";
  import { isScreenL } from "@/utils/media-size";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'PlaceBid',
  props: {
    isMobileBlock: { type: Boolean, default: false }
  },
  emits: ["changeTab"],
  setup(__props: any, { emit: __emit }) {

  const toast = useToast();
  const emit = __emit;

  const auctionStore = useAuctionStore();
  const lots = computed(() => auctionStore.lots);
  const liveLot = computed(() => lots.value.find((item) => item.status === LotStatuses.LIVE));
  const endedLots = computed(() => lots.value.filter((item) => item.status === LotStatuses.ENDED));
  const isAuctionStarted = computed(() => liveLot.value?.id || endedLots.value.length);

  const activeLot = computed(() => auctionStore.activeLot);
  const currentBid = computed(() => auctionStore.activeLot?.current_bid);
  const bidsCount = computed(() => auctionStore.activeLot?.bids_count);
  const userBid = computed(() => (activeLot.value?.id ? auctionStore.user?.bids[activeLot.value?.id] : 0));

  const props = __props;

  const isLockedBidding = computed({
    get: () => auctionStore.isLockedBidding,
    set: (value) => {
      auctionStore.$patch({ isLockedBidding: value });
    }
  });

  const bidVariants = ref(auctionStore.auction.bid_variants);
  const selectedBid = ref(0);
  const isPageVisible = ref(!document.hidden);

  const fastBidVariants = computed(() => bidVariants.value.filter((item) => item > selectedBid.value).slice(0, 3));

  const audioClick = new Audio(clickEffect);
  audioClick.preload = "auto";

  watch(activeLot, (newValue, oldValue) => {
    refreshBidVariants();

    if (newValue?.id !== oldValue?.id) {
      selectItem(bidVariants.value[0]);
    } else {
      selectItem(Math.max(selectedBid.value, bidVariants.value[0]));
    }
  });

  const createSelectedBidWatcher = (sourceRef: Ref<number | undefined>) => {
    watch(sourceRef, (newValue, oldValue) => {
      newValue = newValue ?? 0;
      oldValue = oldValue ?? 0;

      const isMinimalVariantSelected = selectedBid.value === bidVariants.value[0];

      refreshBidVariants();

      if (isMinimalVariantSelected && newValue < oldValue) {
        selectItem(bidVariants.value[0]);
      } else {
        selectItem(Math.max(selectedBid.value, bidVariants.value[0]));
      }
    });
  }

  createSelectedBidWatcher(currentBid);
  createSelectedBidWatcher(bidsCount);
  createSelectedBidWatcher(userBid);


  const handleVisibilityChange = () => {
    isPageVisible.value = !document.hidden;
  };

  onMounted(() => {
    refreshBidVariants();
    selectItem(bidVariants.value[0]);
    document.addEventListener("visibilitychange", handleVisibilityChange);
  });

  onUnmounted(() => {
    document.removeEventListener("visibilitychange", handleVisibilityChange);
  });

  const selectedBidMinus = () => {
    const currentIndex = bidVariants.value.indexOf(selectedBid.value);
    if (currentIndex > 0) {
      selectedBid.value = bidVariants.value[currentIndex - 1];
    }
  };

  const selectedBidPlus = () => {
    const currentIndex = bidVariants.value.indexOf(selectedBid.value);
    selectedBid.value = bidVariants.value[currentIndex + 1];

    if (bidVariants.value.length - currentIndex < 25) {
      auctionStore.addBidVariants();
      refreshBidVariants();
    }
  };

  const refreshBidVariants = () => {
    bidVariants.value = auctionStore.filteredBidVariants();
  };

  const selectItem = (item: number) => {
    selectedBid.value = item;
  };

  const placeBid = (amount: number) => {
    if (activeLot.value?.id) {
      Api.post("/live/lots/" + activeLot.value.id + "/place-bid", { amount })
          .then((response) => {
            if (response.data.success && !auctionStore.user?.is_admin) {
              playSound();
            }
          })
          .catch((error) => {
            console.log(error);

            const errors = error.response.data.errors;
            Object.keys(errors).forEach((key) => {
              errors[key].forEach((error: IPopupError) => {
                toast.add({
                  severity: "error",
                  summary: error.title,
                  detail: error.text,
                  life: 6000
                });
              });
            });
          });
    }
  };

  const playSound = () => {
    audioClick.currentTime = 0;
    audioClick.play();
  };

  const openLockBiddingTab = () => {
    emit("changeTab", "lock");
  };

return (_ctx: any,_cache: any) => {
  return (isLockedBidding.value && !_unref(isScreenL))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(trans)("live.bidding.bidding_locked")), 1),
          _createElementVNode("a", {
            class: "link link-dashed",
            onClick: openLockBiddingTab
          }, _toDisplayString(_unref(trans)("live.bidding.unlock_bidding_tab")), 1)
        ])
      ]))
    : (isAuctionStarted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_Transition, {
                name: isPageVisible.value ? 'current-bid' : ''
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("div", {
                    class: "current-bid",
                    key: currentBid.value ?? 0
                  }, _toDisplayString(_unref(format_currency)(currentBid.value)), 1))
                ]),
                _: 1
              }, 8, ["name"])
            ]),
            _createVNode(CurrencyConverted),
            (_unref(auctionStore).user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['bid-controller btn-minus', { disabled: !bidVariants.value || selectedBid.value === bidVariants.value[0] }]),
                    onClick: selectedBidMinus
                  }, _cache[2] || (_cache[2] = [
                    _createElementVNode("div", { class: "icon-minus" }, null, -1)
                  ]), 2),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", _hoisted_9, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isLockedBidding).value = $event)),
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, isLockedBidding.value]
                      ]),
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "slider round" }, null, -1)),
                      _createVNode(_unref(BaseIcon), {
                        "icon-name": "lock",
                        class: _normalizeClass({ show: !isLockedBidding.value }),
                        "view-box": "0 0 17.721 23.259"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(LockIcon))
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_unref(BaseIcon), {
                        "icon-name": "unlock",
                        class: _normalizeClass({ show: isLockedBidding.value }),
                        "view-box": "0 0 18 24"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(UnlockIcon))
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(isLockedBidding.value ? _unref(trans)("live.bidding.unlock") : _unref(trans)("live.bidding.lock")), 1)
                  ]),
                  (!isLockedBidding.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", {
                          class: "place-bid-btn btn-sky-blue btn-click-effect",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (placeBid(selectedBid.value)))
                        }, _toDisplayString(_unref(trans)("live.bidding.place_bid_btn", { amount: _unref(format_currency)(selectedBid.value) })), 1),
                        _createElementVNode("div", {
                          class: "bid-controller btn-plus",
                          onClick: selectedBidPlus
                        }, _cache[4] || (_cache[4] = [
                          _createElementVNode("div", { class: "icon-plus" }, null, -1)
                        ]))
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(trans)("live.bidding.bidding_locked")), 1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("a", _hoisted_13, _toDisplayString(_unref(trans)("live.bidding.log_in")), 1)
                ]))
          ]),
          (_unref(auctionStore).user && !isLockedBidding.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fastBidVariants.value, (variant, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "fast-bid-variant",
                      key: index,
                      onClick: ($event: any) => (placeBid(variant))
                    }, _toDisplayString(_unref(format_currency)(variant)), 9, _hoisted_16))
                  }), 128))
                ]),
                _createVNode(FastBidVariantsToggle, {
                  "wrapper-class": ".live-bid-block .place-bid-wrapper",
                  target: 
          !props.isMobileBlock ? '.main-panel .fast-bids-variants' : '.mobile-place-bid-block .fast-bids-variants'
        
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("div", { class: "fast-bids-toggle-show" }, null, -1)
                  ])),
                  _: 1
                }, 8, ["target"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
}
}

})